import React from 'react';
import { batch } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import {
  builderDefaultOptionsSelector,
  builderSelectedOptionsSelector,
} from '../../../../../redux/selectors/builder';
import { assertCondition } from '../../../../../utils/types';
import {
  ExpressionModeKey,
  QueryType,
  TimeUnit,
} from '../../../../../utils/apollo/graphqlSchema';
import BuilderEnumSelect from '../../../../../components/Builder/BuilderFields/BuilderEnumSelect';
import {
  resetSegments,
  RowType,
  setExpressionModeAction,
  resetBreakdownGroups,
  setTimeUnit,
} from '../../../../../redux/slices/oldBuilder';
import {
  expressionModeOptionTooltips,
  expressionModeTooltip,
} from '../../../../../components/KubitTooltip/globalTooltips';

const BuilderExpressionMode = () => {
  const dispatch = useAppDispatch();

  const defaultOptions = useAppSelector(builderDefaultOptionsSelector);
  const selectedOptions = useAppSelector(builderSelectedOptionsSelector);

  assertCondition(
    defaultOptions?.type === QueryType.Expression &&
      selectedOptions?.type === QueryType.Expression,
  );

  const breakdownGroups = useAppSelector(
    ({ builder }) => builder.breakdown.groups,
  );
  const segments = useAppSelector(
    ({ builder }) => builder[RowType.breakdownCohorts],
  );

  const options = defaultOptions.modes.map((mode) => ({
    ...mode,
    tooltip: expressionModeOptionTooltips[mode.key],
  }));
  const { mode: selectedMode, timeUnit } = selectedOptions;

  const handleChange = (modeKey: ExpressionModeKey) => {
    batch(() => {
      dispatch(setExpressionModeAction({ modeKey }));

      if (modeKey === ExpressionModeKey.Histogram) {
        if (breakdownGroups.length > 0) {
          dispatch(resetBreakdownGroups());
        }
        if (segments.length > 0) {
          dispatch(resetSegments());
        }
      }

      // ALL_TIME is not available for Impact mode, so we will
      // change time unit to Daily
      if (
        modeKey === ExpressionModeKey.Impact &&
        timeUnit === TimeUnit.AllTime
      ) {
        dispatch(setTimeUnit({ newTimeUnit: TimeUnit.Day }));
      }
    });
  };

  return (
    <BuilderEnumSelect
      label="Mode"
      enumOptions={options}
      selectedOption={selectedMode}
      onChange={handleChange}
      tooltipOption={expressionModeTooltip}
    />
  );
};

export default BuilderExpressionMode;
